import React from "react";
import { Form, Formik, Field, ErrorMessage } from "formik";
import { Col, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import TextError from "../../helpers/FormikHelper/TextError";
import userServices from "../../services/user.services";
import { toast } from 'react-toastify';
import { CenterSchema } from "../../schema/CenterSchema";
import xrayBookingsServices from "../../services/xrayBookings.services";

const initialValues = {
    xray_booking_id:'',
    doctor_id:'',
}

const AssignCardiologistForm = ({ toggle, isAddMode, getAllBookings, selectedRow,doctors }) => {  
     const savedValues = {
        doctor_id: selectedRow?.doctor_id,
    }
    const onSubmit = async (values) => {
        const reqBody = {
            doctor_id: values.doctor_id,
        }
       if(isAddMode==='Add'){
        const result = await userServices.createUser(reqBody);
        if (result.data.status === true) {
            // actions.resetForm();
            getAllBookings()
            toggle()
            toast.success('User registration successfully', { toastId: 'registration_success', autoClose: 3000 });
        } else {
            toast.error(result.data.message, { toastId: 'registration_fail', autoClose: 3000 });
        }
    }else{
        const reqBody = {
            xray_booking_id: selectedRow._id,
            doctor_id: values.doctor_id,
        }
        const result = await xrayBookingsServices.assignCardiologist(reqBody)
        if (result.data.status === true) {
            // actions.resetForm();
            getAllBookings()
            toggle()
            toast.success(result.data.message, { toastId: 'update_success', autoClose: 3000 });
        } else {
            toast.error(result.data.message, { toastId: 'update_fail', autoClose: 3000 });
        }
    }
    }
    return (
        <React.Fragment>
            <Formik
                initialValues={isAddMode==='Add'?initialValues:savedValues}
                // validationSchema={CenterSchema('ADD_CENTER_USER')}
                onSubmit={onSubmit}
                enableReinitialize
            >
               {({  setFieldValue, values }) => (  <Form>
                    <ModalHeader toggle={toggle}>
                        <div className="card-title d-flex align-items-center">
                            <div>
                                <i className="bx bxs-user me-1 font-22 text-primary" />
                            </div>
                            <h5 className="mb-0 text-primary">Assign Radiologist</h5>
                        </div>
                    </ModalHeader>
                    <ModalBody className="">
                        <Col md={12}>
                            <div className="row g-3" >
                            <div className="col-md-12">
                                    <label htmlFor="doctor_id" className="form-label">
                                    Radiologist Name
                                    </label>
                                    <Field as='select' className='form-select' id="doctor_id" name="doctor_id" >
                                        <option  value="">Select Radiologist</option>
                                        {
                                            doctors.map((e, key) => {
                                                return <option key={key} value={e._id}>{e.name}</option>;
                                            })
                                        }
                                    </Field>
                                    <ErrorMessage name="doctor_id" component={TextError} />
                                </div>
                                                   
                              
                            </div>
                        </Col>
                    </ModalBody>
                    <ModalFooter>
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={toggle}
                        >
                            Close
                        </button>
                        <button type="submit" className="btn btn-primary px-5">
                        {isAddMode === "Add" ? "Save" : "Assign"}
                        </button>
                    </ModalFooter>
                </Form>
 )}
            </Formik>
        </React.Fragment>
    );
}

export default AssignCardiologistForm;